import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy, OnInit, Inject } from '@angular/core'
import { fromEvent } from 'rxjs'
import { PLATFORM_ID } from '@angular/core'
import { isPlatformBrowser} from '@angular/common'
import { SharedDataService } from 'src/app/core/services/shared-data.service'
import { LayoutService } from 'src/app/core/services/layout.service'

@Component({
    selector: 'app-component-controls',
    templateUrl: './component-controls.component.html',
    styleUrls: ['./component-controls.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ComponentControlsComponent implements OnInit {

  equipmentProviderInActive: boolean = false
  elementsList: any = []
  _elements: any[][]
  @Input() navigationStyle = 'plain'
  @Input() currentIndex = 0
  @Input() dotsColor = ''
  @Input() cutBy = 4
  @Input() watchElementId: string = null
  @Input() animation: string = null
  @Input() set elements(el: any[]) {
    if (this.isIterable(el)) {
      this._elements = el
      this.cutByNumber(this.cutBy)
    }
  }
  get elements(): any[] {
    return this._elements
  }
  @Output() elementsListEvent: EventEmitter<any> = new EventEmitter()
  @Output() navigateToEvent: EventEmitter<any> = new EventEmitter()

  touchStartX = 0
  touchEndX = 0
  breakpoints = {
    extraSmall: false,
    small: false,
    medium: false,
    large: true,
    extraLarge: true,
  }

  constructor(@Inject(PLATFORM_ID) private platformId: any, 
   public sharedDataService: SharedDataService,
   public layoutService: LayoutService
   ) {

    this.layoutService.subscribeToLayoutChanges().subscribe(
      (observerResponse) => {
        this.breakpoints = this.layoutService.handleLayoutChanges()
      },
      (error: any) => {
        console.error(error)
      }
    )

  }

  ngOnInit(){
    this.equipmentProviderInActive = this.sharedDataService.getPortalType()
    if (isPlatformBrowser(this.platformId) && this.watchElementId !== null) {
    this.addElementTouchSupport()
    }
  

 
  }


  addElementTouchSupport() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    const selector = `#${this.watchElementId}`
    fromEvent(document.querySelector(selector), 'touchstart').subscribe((e: any) => {
      const touchobj = e.changedTouches[0]
      this.touchStartX = touchobj.clientX
    }, (error: any) => {
      console.error(error)
    })
    fromEvent(document.querySelector(selector), 'touchend').subscribe((e: any) => {
      const touchobj = e.changedTouches[0]
      this.touchEndX = touchobj.clientX
      const blindZone = 30
      if (
        this.touchStartX !== this.touchEndX &&
        Math.abs(this.touchStartX - this.touchEndX) > blindZone
      ) {
        if (this.touchEndX < this.touchStartX) {
          this.onNavigationNextClick()
        } else if (this.touchEndX > this.touchStartX) {
          this.onNavigationPrevClick()
        }
      }
    }, (error: any) => {
      console.error(error)
    })
  }

  isIterable(obj) { return Symbol.iterator in Object(obj) }

  cutByNumber(n: number) {
    let itemIndex = 0
    let viewIndex = 0
    for (const i of this.elements) {
      if (itemIndex % n === 0 && itemIndex !== 0) {
        this.elementsList.push([])
        viewIndex++
        this.elementsList[viewIndex].push(i)
      } else if (itemIndex === 0) {
        this.elementsList.push([])
        this.elementsList[viewIndex].push(i)
      } else {
        this.elementsList[viewIndex].push(i)
      }
      itemIndex++
    }
    this.elementsListEvent.emit(this.elementsList)
  }

  onNavigationPrevClick() {
    if (this.currentIndex !== 0) { this.navigateTo(this.currentIndex - 1) }
  }
  onNavigationNextClick() {
    if (this.currentIndex !== this.elementsList.length - 1) {
      this.navigateTo(this.currentIndex + 1)
    }
  }

  async navigateTo(idx: number) {
    if (this.watchElementId !== null) {
      const selector = `#${this.watchElementId}`
      await this.animationsController(idx, selector)
    }

    this.navigateToEvent.emit(idx)
  }

  animationsController(idx: number, selector: string) {
    return new Promise((res) => {
      switch (this.animation) {
        case null:
          res(true)
          break
        case 'slide':
          this.slideAnimation(idx, selector).then(res)
          break
        case 'fade':
          this.fadeAnimation(selector).then(res)
          break
      }
    })
  }
  slideAnimation(idx: number, selector: string) {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    const slideFromRight: boolean = this.currentIndex < idx
    const o = document.querySelector(selector)
    return new Promise((res) => {
      function slideAnimationWrapper(
        slide_in_class: string,
        slide_out_class: string
      ) {
        const animationLength = 300
        const resTime = animationLength / 2
        o.classList.add(slide_out_class)
        setTimeout(() => {
          o.classList.toggle(slide_out_class)
          o.classList.toggle(slide_in_class)
          // res(true)
        }, animationLength)
        setTimeout(() => {
          res(true)
        }, resTime)
        setTimeout(() => {
          o.classList.remove(slide_in_class)
        }, animationLength * 2)
      }
      if (slideFromRight) {
        slideAnimationWrapper('slide-in-right', 'slide-out-left')
      } else {
        slideAnimationWrapper('slide-in-left', 'slide-out-right')
      }
    })
  }

  fadeAnimation(selector: string) {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    const o = document.querySelector(selector)
    return new Promise((res) => {
      const animationLength = 300
      const resTime = animationLength / 2
      o.classList.toggle('fade-out')
      setTimeout(() => {
        o.classList.toggle('fade-in')
        o.classList.remove('fade-out')
        // res(true)
      }, animationLength)
      setTimeout(() => {
        res(true)
      }, resTime)
      setTimeout(() => {
        o.classList.remove('fade-in')
      }, animationLength * 2)
    })
  }
}
